// Standalone inline widget used by the Billing form to validate a coupon code
// against the server in real-time. Extracted from AdminPhaseB.jsx so it can be
// consumed independently without pulling in the whole 700-line tabs module.
import React, { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "../../lib/api";

export const CouponValidator = ({ code, amount, memberId }) => {
    const [res, setRes] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        if (!code || !amount) { setRes(null); return; }
        setBusy(true);
        const t = setTimeout(async () => {
            let isRenewal = false;
            if (memberId) {
                try {
                    const { data } = await api.get("/admin/invoices");
                    isRenewal = data.some((r) => r.member_id === memberId && r.status === "Paid");
                } catch (err) {
                    // Non-fatal: renewal-only coupons will be rejected server-side anyway.
                    if (process.env.NODE_ENV !== "production") console.warn("coupon renewal lookup failed", err);
                }
            }
            api.post("/admin/coupons/validate", { code, amount: Number(amount), is_renewal: isRenewal })
               .then(({ data }) => setRes(data))
               .catch(() => setRes(null))
               .finally(() => setBusy(false));
        }, 400);
        return () => clearTimeout(t);
    }, [code, amount, memberId]);

    if (!code) return null;
    if (busy) return <div className="text-[11px] text-sand/70 mt-1" data-testid="cp-valid-busy">Checking…</div>;
    if (!res) return null;
    return res.valid ? (
        <div className="text-[11px] text-emerald-400 mt-1 flex items-center gap-1" data-testid="cp-valid-ok">
            <CheckCircle2 className="w-3 h-3" /> {res.message}
        </div>
    ) : (
        <div className="text-[11px] text-crimson mt-1 flex items-center gap-1" data-testid="cp-valid-bad">
            <XCircle className="w-3 h-3" /> {res.message}
        </div>
    );
};

export default CouponValidator;
